export enum ChartType {
    Column = 'column',
    GroupedColumn = 'groupedColumn',
    StackedColumn = 'stackedColumn',
    NormalizedColumn = 'normalizedColumn',
    Bar = 'bar',
    GroupedBar = 'groupedBar',
    StackedBar = 'stackedBar',
    NormalizedBar = 'normalizedBar',
    Line = 'line',
    Scatter = 'scatter',
    Bubble = 'bubble',
    Pie = 'pie',
    Doughnut = 'doughnut',
    Area = 'area',
    StackedArea = 'stackedArea',
    NormalizedArea = 'normalizedArea',
    Histogram = 'histogram'
}

export type ChartMenuOptions = 'chartSettings' | 'chartData' | 'chartFormat' | 'chartLink' | 'chartUnlink' | 'chartDownload';